<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             title="改派工单"
             @open="open"
             @closed="closed"
             width="1060px">

    <dispatch-panel :work="work" :dispatch-list="dispatchList" :loading="loading"
                    pattern="DISPATCH"></dispatch-panel>

    <template #footer>
      <el-button type="primary" @click="confirm" :disabled="loading">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
  import { afterWorkProcedures, dispatchWork } from '@/utils/request'
  import DispatchPanel from '@/views/kanban/dialog/confirm-work/DispatchPanel'

  export default {
    name: 'DispatchWorkDialog',
    components: { DispatchPanel },
    props: {
      work: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        loading: false,
        dispatchList: {}
      }
    },
    methods: {
      open () {
        this.loading = true
        afterWorkProcedures(this.work.id).then(response => {
          this.dispatchList = response.data
        }).finally(() => {
          this.loading = false
        })
      },
      closed () {
        this.dispatchList = {}
      },
      cancel () {
        this.hide()
      },
      confirm () {
        this.work.loading = true
        dispatchWork({
          workId: this.work.id,
          procedures: this.dispatchList.procedures
        }).then(() => this.hide())
          .catch(() => {
            this.work.loading = false
          })
      },
      hide () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
